/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { ExternalStyles, HFlow, Text, Theme, useTheme } from 'bold-ui'
import { SimNaoRadioGroupField } from 'components/form'
import { RequiredLabel } from 'components/form/final-form/RequiredLabel/RequiredLabel'
import React from 'react'
import { isUndefinedOrNull } from 'util/checks'
import { Meta, MetaArray } from 'util/metaPath'

interface AccordionItemProps {
  name?: string | MetaArray<any> | Meta<any>
  title: string
  required?: boolean
  borderBottom?: boolean
  clearable?: boolean
  disabled?: boolean
  simNaoField?: boolean
  style?: {
    hFlow?: ExternalStyles
    vFlow?: ExternalStyles
    radioField?: ExternalStyles
  }
  childrenStyles?: ExternalStyles
  children?: React.ReactNode
}

export const AccordionItem = ({
  name,
  title,
  required = false,
  borderBottom = false,
  clearable = false,
  simNaoField = false,
  disabled = false,
  style,
  children,
  childrenStyles,
}: AccordionItemProps) => {
  const theme = useTheme()
  const hasChildren = !isUndefinedOrNull(children)
  const defaultStyles = createStyles(theme, borderBottom, hasChildren)

  return (
    <HFlow alignItems='center' justifyContent='space-between' style={defaultStyles.accordionItem}>
      <div css={defaultStyles.labelContainer}>
        {required ? <RequiredLabel fontWeight='bold' label={title} /> : <Text fontWeight='bold'>{title}</Text>}
      </div>
      {simNaoField && (
        <div css={defaultStyles.radioContainer}>
          <SimNaoRadioGroupField name={name} clearable={clearable} style={style} disabled={disabled} />
        </div>
      )}
      {/* TODO NP: A princípio há somente os SelectFields da seção de Informações Sociodemográficas como children, coloquei o css fixo por que o style por prop não funcionou.
         Daria para evoluir o Bold e dar acesso a style para selectfields com multiple, ou podemos tentar colocar esse componente em um Grid.*/}

      {hasChildren && (
        <div
          css={css([
            css`
              width: 416px;
              margin-left: 2rem;
              white-space: nowrap;
            `,
            childrenStyles,
          ])}
        >
          {children}
        </div>
      )}
    </HFlow>
  )
}

const createStyles = (theme: Theme, borderBottom: boolean, hasChildren: boolean) => ({
  accordionItem: css`
    ${borderBottom ? `border-bottom: 1px solid ${theme.pallete.divider}` : ''};
    padding: 0.5rem;
  `,
  radioContainer: css`
    width: 170px;
    height: 50px;
    margin-left: 1rem;
    display: flex;
    align-items: center;
    margin-top: 0.25rem;
    margin-right: 1.2rem;
  `,
  labelContainer: css`
    margin-left: 20px;
    width: ${hasChildren ? '340px' : '680px'};
  `,
})
